import {useAppState} from "../app/appContext";

export const useIsEkulturAdmin = () => {
    const {user} = useAppState()
    const adminAppId = '0f99554d-4d53-4ce6-ada5-6189f3abdf52'
    return Boolean(user.appAccess?.apps.find(app => app.id === adminAppId))
}